import { createReducerContext } from '../../../../utils/create-reducer-context';
import { AuditSearchState, AuditSearchReducer, ACTION_TYPES } from './audit-search-reducer';

const initialState: AuditSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    drawer: { open: false },
};

const { Provider: AuditSearchProvider, useStateContext: useAuditSearchState, useDispatchContext: useAuditSearchDispatch } = createReducerContext('AuditSearch', AuditSearchReducer, initialState);

export { AuditSearchProvider, useAuditSearchState, useAuditSearchDispatch, ACTION_TYPES };
